import { Component, Input, Output, EventEmitter, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../shared/material/material.module';
import { EnumDescriptionPipe } from '../../shared/pipes/enum-description.pipe';
import { AvailabilityComponent } from '../../shared/availability/availability.component';
import { PageEvent } from '@angular/material/paginator';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DialogRegisterNegotiationComponent } from '../../shared/dialogs/dialog-register-negotiation/dialog-register-negotiation.component';
import { MatDialog } from '@angular/material/dialog';
import { ViewModeService } from '../services/view-mode.service';
import { ComparisonService } from '../services/comparison.service';
import { ComparisonDialogComponent } from '../comparison-dialog/comparison-dialog.component';
import { ExportDialogComponent } from '../export-dialog/export-dialog.component';

@Component({
  selector: 'app-advanced-search-service-results',
  standalone: true,
  imports: [CommonModule, MaterialModule, EnumDescriptionPipe, AvailabilityComponent],
  templateUrl: './advanced-search-service-results.component.html',
  styleUrls: ['./advanced-search-service-results.component.scss']
})
export class AdvancedSearchServiceResultsComponent {
  dialog = inject(MatDialog);
  viewModeService = inject(ViewModeService);
  comparisonService = inject(ComparisonService);

  // Computed signal para o modo de visualização
  viewMode = computed(() => this.viewModeService.viewMode());
  
  // Computed signals para comparação
  comparisonCount = computed(() => this.comparisonService.count());
  canCompare = computed(() => this.comparisonService.canCompare());
  isFull = computed(() => this.comparisonService.isFull());

  @Input() items: any[] = [];
  @Input() isLoading = false;
  @Input() pageSize = 10;
  @Input() pageSizeOptions: number[] = [10, 25, 50];
  @Input() length = 0;
  @Input() serverSide = false;
  @Input() searchConfig: any;

  @Output() page = new EventEmitter<PageEvent>();

  pageIndex = 0;

  get pagedItems(): any[] {
    if (this.serverSide) {
      return this.items;
    }
    const start = this.pageIndex * this.pageSize;
    return this.items ? this.items.slice(start, start + this.pageSize) : [];
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.page.emit(event);
  }

  toggleViewMode(): void {
    this.viewModeService.toggleViewMode();
  }
  
  isItemSelected(itemId: string): boolean {
    return this.comparisonService.isSelected(itemId);
  }
  
  toggleItemSelection(item: any, event: MatCheckboxChange): void {
    const success = this.comparisonService.toggleItem({
      id: item.id,
      type: 'service',
      data: item
    });
    
    // Se não conseguiu adicionar (limite atingido), mostra mensagem
    if (!success && !this.isItemSelected(item.id)) {
      // Item não foi adicionado porque o limite foi atingido
      alert(`Você pode comparar no máximo ${this.comparisonService.getMaxItems()} itens.`);
    }
  }
  
  openComparison(): void {
    const items = this.comparisonService.items();
    
    this.dialog.open(ComparisonDialogComponent, {
      data: { items },
      width: '90vw',
      maxWidth: '1200px',
      maxHeight: '90vh',
      panelClass: 'comparison-dialog-panel'
    });
  }
  
  clearComparison(): void {
    this.comparisonService.clear();
  }

  openExportDialog(): void {
    this.dialog.open(ExportDialogComponent, {
      data: {
        searchCriteria: this.searchConfig,
        results: this.items,
        searchType: 'service'
      },
      width: '600px',
      maxWidth: '90vw',
      disableClose: false,
      panelClass: 'export-dialog-panel'
    });
  }

  createRegisterNegotiation(id: any) {
    const dialogRef = this.dialog.open(DialogRegisterNegotiationComponent, {
      data: {
        initiatorCpfCnpj: this.searchConfig.cpfCnpj,
        referenceId: id,
        referenceType: this.searchConfig.type === 'OFFERING' ? 'serviceOffering' : 'serviceDemand'
      },
    });

    dialogRef.afterClosed().subscribe();
  }
}
